export default {
	game: {
		maintenance: 'मेंटेनेंस',
		maintenance_tip: 'अस्थायी रूप से उपलब्ध नहीं',
		no_more_data: 'और डेटा नहीं',
		search_game_name: 'गेम का नाम खोजें...',
		selected: 'चयनित',
		type: 'प्रकार',
		all_types: 'सभी प्रकार',
		secondary: 'द्वितीयक',
		secondary_category: 'द्वितीयक श्रेणी',
		no_related_games: 'कोई संबंधित गेम नहीं मिला',
		reset_all: 'सभी रीसेट करें',
		end_of_list: 'सूची का अंत',
		game_details: 'गेम विवरण',
		play: 'खेलें',
		bonus_cannot_wagered: 'बोनस पर दांव नहीं लगाया जा सकता',
		entering_game: 'गेम में प्रवेश कर रहे हैं, कृपया प्रतीक्षा करें...',
		entering_game_short: 'गेम में प्रवेश कर रहे हैं...',
		game_types: 'गेम प्रकार',
		game_providers: 'गेम प्रदाता',
		sign_up: 'साइन अप करें',
		search: 'खोजें',
		all_providers: 'सभी प्रदाता',
		loading: 'लोड हो रहा है...',
		my_bet: 'मेरा बेट'
	}
};